var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookLogoJsb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 22,
    fill: "url(#pattern0_1_415)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1_415",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_415",
    transform: "matrix(0.00719424 0 0 0.00752126 0 -0.0227273)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_415",
    width: 139,
    height: 139,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIsAAACLCAYAAABRGWr/AAAACXBIWXMAACE3AAAhNwEzWJ96AAADMUlEQVR4nO3d620TQQCF0QHxH7wV0AHpANIBHZAOoANCBykBOggdkAqgBGhgHSoIMiwSsnhcO7vZGeYcKYqUxzBEn2bsfdj3bm5uCiTu+yuREgsxsRATCzGxEBMLMbEQEwsxsRATCzGxEBMLMbEQEwuxB/5UhxnH7Ukp5XEp5WT6xd3nR38Z5FMp5Xrva9fT179/fxg2+9+vkutZ/mEct7sQnk8fz0opDxf6p06HYfNhobFnYWX5g3Hc7sI4K6W8qHKCKxDLnmmbuSilPK1qYhXwAPcX47g9L6V8FMrvWVl+RLJ7wHpZSnlSwXSq1X0s07bzYcEHrv+NrrchoRym21iEcrguY5mOnbwVymF6XVnOPZg9XHexTAfbXlYwleb0uLKcVzCHJnUVy7SqOOB2pN5WlrMK5tCsbmKZngE5KXgLPa0szyuYQ9PEQqynWJ5VMIemdXEicTqrfBdHa99Pl0t+nj4O8enAn79zvZx1frzw+G92F0y1ci3tsXqJZakt6Otu7GHYVL8qzMGVcrdz3ksopaNYltiGvgzD5mKBcaslluNd3tXka2EbOl7V9/gsQSzH+6+f+fyOWIiJhZhYjmcbItPT8ZWfxEJMLMTEQkwsxMRCTCzExEJMLMTEQkwsxKp/Hdxx3M5x3cjJAlf3X8041u6Fk1/NON4iWrhgu9Yb2eecVxPnmWxDdWjiDLZY6mBlIWZlIWZlIdPKba9iWd+cT8EXJRZiYllfMzeriYWYWNZnZSHWzP1HYllZS/cfiWVdX1uarFjW1dRdjWJZV1P3S4tlXVYWYlYWYk2tLC1cVvlmhjFezzDGvndHvIr2vtv+/p2q/oLtOYzjdon/5OkwbLp6EULbEDGxEBMLMbEQEwsxsRATCzGxEBMLMbEQEwsxsRATCzGxEBMLMbEQEwsxsRATCzGxEBMLMbEQEwsxsRATCzGxEBMLMbEQEwsxsRATCzGxEBMLMbEQEwsxsRATCzGxEBMLMbEQEwsxsRATCzGxEBMLMbEQEwsxsRBr4Z3M5nC1wJhNvb/hHLp4JzPmYRsiJhZiYiEmFmJiISYWYmIhJhZiYiEmFmJiIVNK+QZfg3w46wDgSgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogoJsb);
export default __webpack_public_path__ + "static/media/facebook-logo-jsb.70af5f32838db72ba7c06ced7ee24107.svg";
export { ForwardRef as ReactComponent };